import type { Snippet } from 'svelte';
import type { DeviceName } from '@athena-lib/device';
import { getResponsiveClasses } from '@athena-lib/responsive-utils';
import type { Color } from '@athena-lib/colors';

export type HeadingSize =
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge';
const headingLevels = [1, 2, 3, 4, 5] as const;
export type HeadingLevel = (typeof headingLevels)[number];
export const parseHeadingLevel = (input: string | undefined): HeadingLevel | undefined => {
  if (input === undefined || input.trim() === '') {
    return undefined;
  }
  const parsed = parseInt(input);
  return headingLevels.find((x) => parsed === x);
};
export type ResponsiveHeadingSize = Partial<Record<DeviceName, HeadingSize>>;

export type BaseHeadingProps = {
  children: Snippet;
  level: HeadingLevel;
  color?: Color;
  element?: string;
  size?: HeadingSize | ResponsiveHeadingSize;
  class?: string;
  id?: string;
};

export function getHeadingSizeClasses(size: HeadingSize | ResponsiveHeadingSize | undefined) {
  return getResponsiveClasses(size, headingSizes);
}

export const headingSizes = {
  default: {
    xxsmall: 'text-st-sm-xxsmall lg:text-st-lg-xxsmall',
    xsmall: 'text-st-sm-xsmall lg:text-st-lg-xsmall',
    small: 'text-st-sm-small lg:text-st-lg-small',
    medium: 'text-st-sm-medium lg:text-st-lg-medium',
    large: 'text-st-sm-large lg:text-st-lg-large',
    xlarge: 'text-st-sm-xlarge lg:text-st-lg-xlarge',
    xxlarge: 'text-st-sm-xxlarge lg:text-st-lg-xxlarge',
  },

  sm: {
    xxsmall: 'text-st-sm-xxsmall',
    xsmall: 'text-st-sm-xsmall',
    small: 'text-st-sm-small',
    medium: 'text-st-sm-medium',
    large: 'text-st-sm-large',
    xlarge: 'text-st-sm-xlarge',
    xxlarge: 'text-st-sm-xxlarge',
  },

  md: {
    xxsmall: 'md:text-st-md-xxsmall',
    xsmall: 'md:text-st-md-xsmall',
    small: 'md:text-st-md-small',
    medium: 'md:text-st-md-medium',
    large: 'md:text-st-md-large',
    xlarge: 'md:text-st-md-xlarge',
    xxlarge: 'md:text-st-md-xxlarge',
  },

  lg: {
    xxsmall: 'lg:text-st-lg-xxsmall',
    xsmall: 'lg:text-st-lg-xsmall',
    small: 'lg:text-st-lg-small',
    medium: 'lg:text-st-lg-medium',
    large: 'lg:text-st-lg-large',
    xlarge: 'lg:text-st-lg-xlarge',
    xxlarge: 'lg:text-st-lg-xxlarge',
  },
};
